import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import { SidebarNav } from './components';
import { styled } from '@mui/material/styles';

interface Props {
  onClose: () => void;
  open: boolean;
  variant: 'permanent' | 'persistent' | 'temporary' | undefined;
  navItems: Array<NavItem | NavDropDown>;
  children?: React.ReactNode;
}

interface ContentProps {
  open?: boolean;
  drawerWidth: number;
}

const Content = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'drawerWidth'
})<ContentProps>(({ theme, open, drawerWidth = 0 }) => ({
  flexGrow: 1,
  padding: theme.spacing(0),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: `${drawerWidth}px`,
  }),
}));

function Sidebar({ navItems, open, variant, onClose, children }: Props): JSX.Element {
  return (
    <>
      <Drawer
        anchor="left"
        onClose={() => onClose()}
        open={open}
        variant={variant}
        sx={{
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: 280,
          },
        }}
      >
        <Box
          sx={{
            height: '100%',
            padding: 1,
          }}
        >
          <SidebarNav navItems={navItems} closeSidebar={onClose} />
        </Box>
      </Drawer>
      {children && (
        <Content open={open && (variant !== 'temporary')} drawerWidth={280}>
          {children}
        </Content>
      )}
    </>
  );
}

export default Sidebar;
